/* eslint max-classes-per-file: 0 */

import {
  NotificationPage as Data,
  NotificationPageCollection as Collection,
} from '@/typings/api/NotificationPage'
import { NotificationsPagesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class FormDataTransformerParams extends TransformerParams {
}

export class NotificationPagesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new FormDataTransformerParams();
}
